import styled from "styled-components";

const StyledPreviewWrapper = styled.div`
  display: block;
  width: 100%;
  align-self: flex-start;
  position: relative;
`;

export default StyledPreviewWrapper;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledPreviewWrapper.js